import type { PropsWithChildren } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import _BaseLabel from './_BaseLabel'

export type MessagingLabelVariant =
  | 'urgencyNormal'
  | 'successLight'
  | 'warningLight'
  | 'criticalLight'
  | 'criticalNormal'

const MessagingLabelElement = styled(_BaseLabel)`
  &.variant-urgencyNormal {
    background-color: ${props => props.theme.palette.messaging.urgency.normalBackground};
    border-color: ${props => props.theme.palette.messaging.urgency.normalForeground};
    color: ${props => props.theme.palette.messaging.urgency.normalContrast};
  }

  &.variant-successLight {
    background-color: ${props => props.theme.palette.messaging.success.lightBackground};
    border-color: ${props => props.theme.palette.messaging.success.lightForeground};
    color: ${props => props.theme.palette.messaging.success.lightContrast};
  }

  &.variant-warningLight {
    background-color: ${props => props.theme.palette.messaging.warning.lightBackground};
    border-color: ${props => props.theme.palette.messaging.warning.lightForeground};
    color: ${props => props.theme.palette.messaging.warning.lightContrast};
  }

  &.variant-criticalLight {
    background-color: ${props => props.theme.palette.messaging.critical.lightBackground};
    border-color: ${props => props.theme.palette.messaging.critical.lightForeground};
    color: ${props => props.theme.palette.messaging.critical.lightContrast};
  }

  &.variant-criticalNormal {
    background-color: ${props => props.theme.palette.messaging.critical.normalBackground};
    border-color: ${props => props.theme.palette.messaging.critical.normalForeground};
    color: ${props => props.theme.palette.messaging.critical.normalContrast};
  }
`

interface Props {
  variant: MessagingLabelVariant
  className?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
  format?: React.ComponentProps<typeof _BaseLabel>['format']
}

/**
 * Documentation: <https://aussiecommerce.atlassian.net/wiki/spaces/UXUI/pages/4504289338/Label>
 */
function MessagingLabel({ className, variant, ...labelProps }: PropsWithChildren<Props>) {
  return <MessagingLabelElement
    className={clsx(
      className,
      `variant-${variant}`,
    )}
    {...labelProps}
  />
}

export default MessagingLabel
